import GeneralLedgerLayout from '@/modules/general-ledger/layout/GeneralLedgerLayout.vue';

const routes = [
  {
    path: 'transaction-posting-cheque',
    name: 'transaction-posting-cheque',
    component: () => import('@/modules/general-ledger/views/transaction-posting/Cheque.vue')
  },
  {
    path: 'transaction-posting-journals',
    name: 'transaction-posting-journals',
    component: () => import('@/modules/general-ledger/views/transaction-posting/Journals.vue')
  },
  {
    path: 'transaction-posting-receipts',
    name: 'transaction-posting-receipts',
    component: () => import('@/modules/general-ledger/views/transaction-posting/Receipts.vue')
  },
  {
    path: 'chart-of-accounts',
    name: 'chart-of-accounts',
    component: () => import('@/modules/general-ledger/views/ChartOfAccounts.vue')
  },
  {
    path: 'cheque-requisition',
    name: 'cheque-requisition',
    component: () =>
      import('@/modules/general-ledger/views/ChequeRequisition.vue')
  },
  {
    path: 'ledgers',
    name: 'ledgers',
    component: () =>
      import('@/modules/general-ledger/views/Ledgers.vue')
  },
  {
    path: 'manage-loan-account',
    name: 'manage-loan-account',
    component: () =>
      import('@/modules/general-ledger/views/ManageLoanAccount.vue')
  },
  {
    path: 'pool',
    name: 'pool',
    component: () =>
      import('@/modules/general-ledger/views/GeneralLedgerPool.vue')
  },
  {
    path: 'pending-requisition-approval',
    name: 'pending-requisition-approval',
    component: () =>
      import('@/modules/general-ledger/views/workload/PendingRequisitionApproval.vue')
  },
  {
    path: 'write-cheque-requests',
    name: 'write-cheque-requests',
    component: () =>
      import('@/modules/general-ledger/views/workload/WriteChequeRequests.vue')
  },
  {
    path: 'pending-journal-approval',
    name: 'pending-journal-approval',
    component: () =>
      import('@/modules/general-ledger/views/workload/PendingJournalApproval.vue')
  },
  {
    path: 'pending-payout',
    name: 'pending-payout',
    component: () =>
      import('@/modules/general-ledger/views/workload/PendingPayout.vue')
  },
];

export default {
  path: 'general-ledger',
  name: 'general-ledger',
  component: GeneralLedgerLayout,
  redirect: {
    name: 'transaction-posting-cheque'
  },
  meta: {
    requiresAuth: true
  },
  children: [...routes]
};
